// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1PGr-","highlight":"styles_highlight__13wWw"};